<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
library.add(faEdit)
</script>
<template>
  <FontAwesomeIcon icon="fa-solid fa-edit" />
</template>
